module.exports = __webpack_public_path__ + "img/phone_call.cdc4d3a7.png";